import type { FeatureRoutes } from '@/app/screens'

export default {
  screens: { callLog: () => import('./CallLogPage.vue') },
} satisfies FeatureRoutes
